import { Moment } from 'moment';

import { Mention } from '../../../Mentions/models/mention';
import { TVEyesPlayerletteUrl } from '../../../Mentions/models/tveyes-playerlette-url.model';

export interface TVEyesTimelineThumbnail {
    datetime: string;
    url: string;
}

export interface TVEyesTimelineDateTimesForPage {
    start: Moment;
    end: Moment;
}


export class TVEyesTimeline {
    private pageToThumbnailMap = new Map<number, TVEyesTimelineThumbnail[]>();
    private mention: Mention;
    private keywords: string[];
    private baseClip: TVEyesPlayerletteUrl;
    private currentClip: TVEyesPlayerletteUrl;

    constructor(
        mention: Mention,
        baseClipStartDate: Moment,
        keywords: string[],
    ) {
        this.mention = mention;
        this.keywords = keywords;

        this.baseClip = TVEyesPlayerletteUrl.fromUrl(mention.url);
        this.baseClip.setStartDateTime(baseClipStartDate);
        this.currentClip = this.baseClip.clone();
    }

    getBaseClipStartDateTime(): Moment {
        return this.baseClip.getStartDateTime();
    }

    getCurrentClip(): TVEyesPlayerletteUrl {
        return this.currentClip;
    }

    setCurrentClip(clip: TVEyesPlayerletteUrl) {
        this.currentClip = clip;
    }

    getOriginalMention(): Mention {
        return this.mention;
    }

    getOriginalKeywords(): string[] {
        return this.keywords;
    }

    getTimelineThumbnailsByPage(page: number): TVEyesTimelineThumbnail[] {
        return this.pageToThumbnailMap.get(page);
    }

    setTimelineThumbnailsOnPage(page: number, thumbnails: TVEyesTimelineThumbnail[]) {
        this.pageToThumbnailMap.set(page, thumbnails);
    }
}
